exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".request-content[data-v-4b97d02b],.request-title[data-v-4b97d02b]{width:100%;margin-bottom:16px}.request-email[data-v-4b97d02b]{width:100%;margin-bottom:32px}.request-item-value[data-v-4b97d02b],.request-message[data-v-4b97d02b],.title-input[data-v-4b97d02b]{width:100%}.content-input[data-v-4b97d02b]{width:100%;min-height:176px;max-height:176px}.email-input[data-v-4b97d02b]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b97d02b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components2/Robo/modal/RoboCreateRequest.vue
// module id = TB+4
// module chunks = 3